import React, { useState, useEffect, useMemo } from 'react';
import { TableContainer,Paper,TableSortLabel, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Box,  Menu, Typography, CircularProgress, Grid, MenuItem, Dialog,DialogTitle, DialogContent,DialogContentText, DialogActions,Button } from '@mui/material';
import SlidingPanel from './../SlidingPanel';
import HistoryPanel from './../HistoryPanel';
import { fetchService } from '../Services/fetchService';
import { REPORT_TYPE_LISTING_TITLE, DELIVERY_FREQUENCY_LABELS, STATUS_LABELS, REPORT_TYPE_URLS } from '../Constant/reportMappings';
import { Snackbar, Alert } from '@mui/material';
import DmpIcons from "../../../components/DmpIcons/icons";
import SearchTableInput from "components/SearchTableInput/SearchTableInput";
import { COLUMNS_HEADER, TOOLTIP_TEXT } from '../Constant/listColumn';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from './../../../assets/images/edit.svg';
import { useParams } from "react-router-dom";
import {APP_REPORT_CENTER_API_ENDPOINT} from "./../../../constants/api_urls";
import CustomPagination from "../../../components/CustomPagination";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import './styles.scss';

const Listing = ({ reports , loading , showSnackbar, refreshData }) => {
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(reports);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedReport, setSelectedReport] = useState(null); 
  const [showForm, setShowForm] = useState(false); 
  const [showHistory, setShowHistory] = useState(false); 
  const [historyRecords, setHistoryRecords] = useState(false); 
  const [reportType, setReportType] = useState('');
  const [reportName, setReportName] = useState('');
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeReportId, setActiveReportId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const { idaccount } = useParams();

  useEffect(() => {
    setRows(reports);
  }, [reports]); 

  const handleRequestSort = (columnId) => {
    const isAsc = orderBy === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(columnId);
  };

  const handleChangePage = (event, newPage) => {
      setPage(newPage - 1);
  };

  const handleRowsPerPageChange = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
  };

  const handleCloseSnackbar = () => setSnackbarOpen(false);

  const handleSettingsClick = (event, reportId) => {
    setAnchorEl(event.currentTarget);
    setActiveReportId(reportId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveReportId(null);
  };

  const fetchReports = async (API_URL, reportId) => {
    try {
      const reportResponse = await fetchService(`${API_URL}?account=${idaccount}&report_id=${reportId}`);
      if (reportResponse.success) {
        setSelectedReport(reportResponse.data[0]);
      } else {
        const errorMessage = reportResponse.errors.length > 0
          ? reportResponse.errors[0].message
          : 'Unknown error occurred';
        setError(errorMessage);
      }
    } catch (err) {
      setError('Failed to load reports');
    }
  }

  const handleEdit = (report) => {  
    const detailURL = REPORT_TYPE_URLS[report.report_type]; 
    if (detailURL) {
      fetchReports(detailURL, report.id);
      setReportType(report.report_type);
      setShowForm(true);
    } else {
      console.error(`Unknown report type: ${report.report_type}`);
    }
  };

  const handleFileHistory =   async (reportId, reportType, reportName) => {  
    try {
      const reportResponse = await fetchService(`${APP_REPORT_CENTER_API_ENDPOINT}/api/report/file-history?report_id=${reportId}`, "GET");
        setHistoryRecords(reportResponse.data)
        setReportType(reportType);
        setReportName(reportName);
        setShowHistory(true);
    } catch (err) {
      setError('Failed to load history');
    }
  };

  const handleChangeStatus = async (reportId, status) => {
    try {
      if (status === "DELETED") {
        setSelectedReportId(reportId);
        setConfirmOpen(true);
      }
      const reportResponse = await fetchService(`${APP_REPORT_CENTER_API_ENDPOINT}/api/reports/update-status?report_id=${reportId}&status=${status}`, "PATCH");
      if (reportResponse.success) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === reportId ? { ...row, status } : row
          )
        );
        setSnackbarMessage(`Status of report ID ${reportId} has been updated to ${status}`);
        setSnackbarOpen(true);
      } else {
        const errorMessage = reportResponse.errors.length > 0
          ? reportResponse.errors[0].message
          : 'Unknown error occurred';
        setError(errorMessage);
        if(error.length > 0){
          setSnackbarOpen(true);
        }
      }
    } catch (err) {
      setError('Failed to load reports');
      if(error.length > 0){
        setSnackbarOpen(true);
      }
    }
  }

  const handleExecute = async (reportId) => {
    try {
      const reportResponse = await fetchService(`${APP_REPORT_CENTER_API_ENDPOINT}/api/report/execute?report_id=${reportId}`, "PATCH");
      if (reportResponse.success) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === reportId ? { ...row, execute: false  } : row
          )
        );
        setSnackbarMessage(`Report ID ${reportId} was executed`);
        setSnackbarOpen(true);
      } else {
        const errorMessage = reportResponse.errors.length > 0
          ? reportResponse.errors[0].message
          : 'Unknown error occurred';
        setError(errorMessage);
      }
    } catch (err) {
      setError('Failed to load reports');
    }
  }
  
  const handleDeleteConfirm = (reportId) => {
    setSelectedReportId(reportId);
    setConfirmOpen(true);
  };

  const handleConfirmClose = (confirmed) => {
    try {
      if (confirmed) {
        handleChangeStatus(selectedReportId, "DELETED").then(() => {
          setRows((prevRows) => prevRows.filter(row => row.id !== selectedReportId));
        });
      }
    } catch (err) {
      setError('Error trying to delete.');
      if(error.length > 0){
        setSnackbarOpen(true);
      }
    }
    setConfirmOpen(false);
    setSelectedReportId(null);
  };

  const calculateColumnWidth = (label) => {
    const baseWidth = 148;
    const charWidth = 10;
    return Math.max(baseWidth, label.length * charWidth);
  };

  const filteredData = useMemo(() => {
      if (!searchQuery) return rows;
      return rows.filter(row => {
          return COLUMNS_HEADER.some(column => {
              const value = column.id
                  ? column.id.split('.').reduce((obj, key) => (obj ? obj[key] : null), row)
                  : null;
              return value && value.toString().toLowerCase().includes(searchQuery.toLowerCase());
          });
      });
  }, [rows, searchQuery]);

  // Sorting logic
  const sortedRows = filteredData.sort((a, b) => {
    if (order === 'asc') {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);  

  // Pagination logic
  const paginatedReports = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return (
    <>
      <Paper className="report-listing-table">
        <Grid item xs={12}>
          <Box className="table-header-report"  sx={{ backgroundColor: '#EBEBEB', padding: "0.5rem" }}>
          <SearchTableInput
                        placeholder={'Search'}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
          </Box>
        </Grid>
        <Box sx={{position: 'relative', width: '100%'}}>
          {/* Loader Container */}
          {loading && (
              <Box className="loader">
                  <CircularProgress/>
                  <Typography variant="body2" sx={{marginLeft: 1}}>Loading...</Typography>
              </Box>
          )}

          <Box className='reportCenterContainerBox'>
              <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow sx={{height: '40px'}}>
                        {COLUMNS_HEADER.map((column) => (
                          <TableCell
                            key={column.id}
                            sortDirection={orderBy === column.id ? order : false}
                            sx={{
                                padding: '4px 8px',
                                fontSize: '0.75rem',
                                textAlign: 'left',
                                justifyContent:'left!important',
                                width: calculateColumnWidth(column)
                            }}
                          >
                          <Tooltip
                              title={
                                  TOOLTIP_TEXT.find((tooltip) => tooltip.id === column.id)?.label || column.id
                              }
                              placement="bottom">
                              <TableSortLabel
                                  active={orderBy === column.id}
                                  direction={orderBy === column.id ? order : 'asc'}
                                  onClick={() => handleRequestSort(column.id)}
                                  sx={{ display: 'flex'}}>
                                  {column.label}
                              </TableSortLabel>
                          </Tooltip>
                          </TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  { paginatedReports.length > 0 ? (
                      paginatedReports.map((report) => {
                        const formattedDate = new Date(report.date_created).toLocaleDateString('en-GB');
                        const isRunning = report.status === 'RUNNING';
                        const isExecute = report.execute === true;
                        const fileHistoryVisible = report?.fileHistoryVisible === true;
                        const isUserDeleted = report?.is_user_deleted  === true;
                        return (
                          <TableRow hover tabIndex={-1} key={report.id} sx={{ height: '40px' }} >
                            <TableCell>{report.id}</TableCell>
                            <TableCell>{report.name}</TableCell>
                            <TableCell>
                              <IconButton  className={(activeReportId === report.id ) ? 'active' : '' }  aria-label="settings" onClick={(event) => handleSettingsClick(event, report.id)}>
                                <DmpIcons.ActionsIcons.CogsGrayIcon className="cogicon" />
                              </IconButton>
                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl) && activeReportId === report.id}
                                onClose={handleMenuClose}
                                className="listing-menu-options-report"
                              >
                                <MenuItem onClick={() => { handleEdit(report); handleMenuClose(); }}>
                                <img src={EditIcon} alt="Edit" className="icon" />
                                  Edit
                                </MenuItem>
                                {fileHistoryVisible && (
                                <MenuItem className='menu-history-download' onClick={() => { handleFileHistory(report.id,report?.report_type, report?.name); handleMenuClose(); }} >
                                 <DownloadOutlinedIcon sx={{ fontSize: "17px", marginRight: 1 }} />
                                 File History
                                  </MenuItem>
                                )}
                                {!isUserDeleted && (
                                  <>
                                    {isRunning ? (
                                      <MenuItem className='menu-paused' onClick={() => { handleChangeStatus(report.id, "PAUSED"); handleMenuClose(); }}>
                                        <img src={DmpIcons.ReportCenter.IconPause} alt="Pause" className="icon" />
                                        Pause
                                      </MenuItem>
                                    ) : (
                                      <MenuItem onClick={() => { handleChangeStatus(report.id, "RUNNING"); handleMenuClose(); }}>
                                        <img src={DmpIcons.ReportCenter.IconPause} alt="Pause" className="icon" />
                                        Resume
                                      </MenuItem>
                                    )}
                                    {isExecute && (
                                      <MenuItem  onClick={() => { handleExecute(report.id); handleMenuClose(); }} >
                                        <img src={DmpIcons.ReportCenter.IconPlay} alt="Execute" className="icon" />
                                        Execute 
                                      </MenuItem>
                                    )}
                                    <MenuItem className='menu-deleted' onClick={() => { handleDeleteConfirm(report.id); handleMenuClose(); }}>
                                      <img src={DmpIcons.ReportCenter.IconDelete} alt="Delete" className="icon" />
                                      Delete 
                                    </MenuItem>
                                    </>  
                                )}
                              </Menu>
                            </TableCell>
                            <TableCell>{REPORT_TYPE_LISTING_TITLE[report.report_type] || report.report_type}</TableCell>
                            <TableCell>{report.meta_search}</TableCell>
                            <TableCell>{formattedDate}</TableCell>
                            <TableCell>{DELIVERY_FREQUENCY_LABELS[report.delivery_frequency] || report.delivery_frequency}</TableCell>
                            <TableCell>{STATUS_LABELS[report.status] || report.status}</TableCell>
                            <TableCell>{report.owner_username}</TableCell>
                          </TableRow>
                      );
                    })
                    ) : (
                      <TableRow sx={{ height: '40px' }}>
                        <TableCell className='no-record-avaiable' colSpan={9} sx={{ textAlign: 'center', padding: 2 }}>
                          <Typography sx={{ fontSize: '0.75rem' }}>No records available</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                    <Dialog open={confirmOpen} onClose={() => handleConfirmClose(false)} >
                      <DialogTitle>Confirm Delete</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Are you sure you want to delete this report? This action cannot be undone.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                              variant="outlined"
                              onClick={() => handleConfirmClose(false)}
                              className='cancelBtn'
                          >
                              Cancel
                          </Button>
                          <Button
                              variant="outlined"
                              onClick={() => handleConfirmClose(true)}
                              className='deleteBtn'
                          >
                              Delete
                          </Button>
                      </DialogActions>
                    </Dialog>

                    </TableBody>
                  </Table>
              </TableContainer>
          </Box>
        </Box>
      </Paper>

      {/*Add Pagination component*/}
      <CustomPagination rowsPerPage={rowsPerPage} pageCount={totalPages} page={page + 1} handleChangePage={handleChangePage} handleRowsPerPageChange={handleRowsPerPageChange} />
            
      <SlidingPanel open={showForm} onClose={() => setShowForm(false)} skipStep1={false} showSnackbar={showSnackbar} report_type={reportType} reportData={selectedReport} isEdit= {true} initial={true} refreshData= {refreshData}  /> 
      <HistoryPanel open={showHistory} onClose={() => setShowHistory(false)} records ={historyRecords} report_type={reportType} report_name={reportName} /> 
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={3000} 
        onClose={handleCloseSnackbar} 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Listing;
